var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".intro[data-v-1bf0662b]{background-image:url(" + escape(require("../assets/images/temp/intro-image-2.png")) + ")}", ""]);

// exports
